import React from 'react';
import { Columns, Column } from 'components/Columns';
import Portfolios from './Portfolios';
import Comments from '../../components/Comments';
import SimpleTable from 'modules/Tables/SimpleTable';
import LoadingBar from '@hubins/components/LoadingIndicators';
import Heading from '@hubins/components/Heading';
import __ from 'localisation';
import BackofficeProfileAttributes from '@hubins/components/BackofficeProfileAttributes';
import TaxDomiciles from '@hubins/components/TaxDomiciles';

const typeValueHeaders = [
  {
    Header: '',
    accessor: 'type',
  },
  {
    Header: '',
    accessor: 'value',
  }
];



const Overview = ({profile, backOfficeUser}) => {

  return (
    <Columns>
      <Column l="6">
        <Heading size={"4"} className='s-bottom-m'>{__('menu_users')}</Heading>
        <BackofficeProfileAttributes profile={profile} canEdit={backOfficeUser} />
        <Heading size="5" className='s-bottom-m s-top-l'>{__('tax_domiciles')}</Heading>
        <TaxDomiciles profileUuid={profile.uuid} backofficeUser={backOfficeUser} />
      </Column>
      <Column l="6">
        <Heading size={"4"} className='s-bottom-m'>{__('portfolios')}</Heading>
        <Portfolios profileUuid={profile.uuid} />

      </Column>
      <Column xs="12">
        <Comments
          model='Profile'
          modelUuid={profile.uuid}
          presetChannels={['hubins_backoffice', 'hubins_compliance', 'quantum_backoffice', 'quantum_compliance']}
        />
      </Column>
    </Columns>
  )
};

export default Overview;